import { render, staticRenderFns } from "./SendInvitationLink.vue?vue&type=template&id=1c3e22da&scoped=true&"
import script from "./SendInvitationLink.vue?vue&type=script&lang=js&"
export * from "./SendInvitationLink.vue?vue&type=script&lang=js&"
import style0 from "./SendInvitationLink.vue?vue&type=style&index=0&id=1c3e22da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e22da",
  null
  
)

export default component.exports